/**
 * /ai-import-return: after Submit, opens the screen the import started from
 * (/designers/:id or /order-detail/:id) with the sub-unit preselected.
 * The link is built by the server (aiCommitCtrl returnPathFor).
 */
import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { listUnits } from '../services/orderUnitApi';
import { logger } from '../utils/logger';

const OBJECT_ID = /^[0-9a-f]{24}$/i;

const AiImportReturn = () => {
  const navigate = useNavigate();
  const { search } = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(search);
    const orderId = params.get('orderId') || '';
    const orderNumber = (params.get('orderNumber') || '').trim();
    const page = params.get('page') === 'designers' ? 'designers' : 'order';

    if (!OBJECT_ID.test(orderId)) {
      navigate('/', { replace: true });
      return undefined;
    }

    const target = page === 'designers'
      ? `/designers/${orderId}`
      : `/order-detail/${orderId}?from=ai-import`;

    let cancelled = false;
    (async () => {
      let state;
      // A sub-unit number ("IN101941.A2"): select that unit on arrival.
      if (orderNumber.includes('.')) {
        try {
          const res = await listUnits(orderId);
          const unit = (res.units || []).find((u) => u.unit_order_number === orderNumber);
          if (unit) state = { preselectUnitId: unit._id, orderNumber };
        } catch (err) {
          // Still open the screen; it falls back to its first unit.
          logger.error('[AiImportReturn] could not look up the sub-unit', err);
        }
      }
      if (!cancelled) navigate(target, { replace: true, state });
    })();

    return () => { cancelled = true; };
  }, [search, navigate]);

  return <div style={{ padding: 24 }}>Opening the order…</div>;
};

export default AiImportReturn;
